import axios from "../general/HttpClient";

let organizations = [];

let subscriptions = [];

export function subscribe(cb) {
    subscriptions.push(cb);
    dispatch();
}

export function unsubscribe(cb) {
    subscriptions = subscriptions.filter((s) => s == cb);
}

function dispatch() {
    subscriptions.forEach((s) => s(organizations));
}

export function getOrganizations(subscription?) {
    if (subscription) subscribe(subscription);
    return axios.get("/api/Organizations").then((response) => {
        organizations = response.data.map((o) => {
            o.defaultDomain = o.defaultDomain || "";
            return o;
        });
        dispatch();
        return organizations;
    });
}

export function getOrganization(id) {
    return axios.get(`/api/Organizations/${id}`).then((response) => {
        response.data.defaultDomain = response.data.defaultDomain || "";
        return response.data;
    });
}

export function updateOrganization(id, organization) {
    return axios.put(`/api/Organizations/${id}`, organization).then((response) => {
        getOrganizations();
        return response.data;
    });
}

export function createOrganization(data) {
    return axios.post("/api/Organizations", data).then((response) => {
        getOrganizations();
        return response.data;
    });
}

export function ListRegisterLinks(organizationId) {
    return axios.get("/api/Organizations/ListRegisterLinks", {
        params: {
            organizationId,
        },
    });
}

export function CreateRegisterLink(organizationId, membershipType) {
    return axios.post(
        "/api/Organizations/CreateRegisterLink",
        { type: membershipType },
        {
            params: {
                organizationId,
            },
        }
    );
}

export function SendRegisterLink(link, recipients, message) {
    return axios.post(
        "/api/organizations/sendRegisterLink",
        {
            to: recipients,
            message,
        },
        { params: { registerLink: link.id } }
    );
}

export function DisableRegisterLink(organizationId, id) {
    return axios.delete("/api/Organizations/DisableRegisterLink", {
        params: {
            organizationId,
            id,
        },
    });
}

export function EnableRegisterLink(organizationId, id) {
    return axios.post(
        "/api/Organizations/EnableRegisterLink",
        {},
        {
            params: {
                organizationId,
                id,
            },
        }
    );
}

export function MembershipType(type) {
    switch (type) {
        case 0:
            return "Staff";
        case 1:
            return "Student";
        case 2:
            return "Parent";
        case 3:
            return "Guest";
    }
}

export function CreateBranding(id) {
    return axios.post(`/api/Branding/`, {
        organizationId: id,
    });
}
export function UpdateBranding(id, branding) {
    return axios.post(`/api/Branding/${id}`, branding);
}

export function GetBranding(id) {
    return axios.get(`/api/Branding/${id}`);
}

export function AddDomain(id, domain) {
    return axios.post(`/api/Branding/${id}/addDomain`, {}, { params: { domain } });
}

export function RemoveDomain(id, domain) {
    return axios.post(`/api/Branding/${id}/removeDomain`, {}, { params: { domain } });
}
export function GetBrandingDomains(id) {
    return axios.get(`/api/Branding/${id}/domains`);
}
